import { Component } from '@angular/core';
import { FooterLink } from '@maced/angular-components';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  meeUrl = 'https://www.macmillaneducationeverywhere.com';
  logoTarget = '_blank';
  copyright = '<span class="c-footer__copy-right--company-name">© Macmillan Education Limited 2021 </span><span class="c-footer__copy-right--company-number">Company number: 1755588 </span><span class="c-footer__copy-right--vat-number">VAT number: 199 4406 21</span><span class="c-footer__copy-right--version"> Version 1.5.5.72</span>';

  links: FooterLink[] = [
    { label: 'Terms and conditions', url: this.meeUrl + '/terms-conditions', target: '_blank', srOnlyLabel:'open in new window' },
    { label: 'Cookies policy', url: 'https://myclasses.macmillaneducationeverywhere.com/MEE/CookiePolicy', target: '_blank', srOnlyLabel:'open in new window' },
    { label: 'System requirements', url: this.meeUrl + '/system-requirements', target: '_blank', srOnlyLabel:'open in new window' },
    { label: 'Privacy Policy', url: this.meeUrl + '/privacy-policy', target: '_blank', srOnlyLabel:'open in new window' },
    { label: 'Modal Header', url: 'modal-header', target: '_self', srOnlyLabel:'open in new window' },
    { label: 'For parents', url: this.meeUrl + '/for-parents', target: '_blank', srOnlyLabel:'open in new window' }
  ];
}